<span [style]="labelStyle">{{label}}</span>
